/* Copyright 2024 City Trax Limited. All rights reserved. */
import { useCallback, useEffect, useState } from 'react';
import { FaFile } from "react-icons/fa";
import { useLocation } from 'react-router-dom';
import { get, del } from 'aws-amplify/api';
import { fetchAuthSession } from 'aws-amplify/auth'
import {
    Container,
    Header,
    Table,
    Box,
    SpaceBetween,
    Button,
    Flashbar,
    Link
} from '@cloudscape-design/components';
import {
    useNavigate,
} from "react-router-dom";

// TODO auto refresh table
// TODO add search to table, add filters to table
function getDate(date) {
    var a = new Date(date * 1000);
    var year = a.getFullYear();
    var month = a.getMonth() + 1;
    date = a.getDate();
    var hour = a.getHours();
    var min = a.getMinutes();
    var time = date + '/' + month + '/' + year + ':' + hour + ':' + min;
    return time;
}

function TextTunerList() {
    const { state } = useLocation();
    const [flashItem, setFlashItem] = useState([
        {
            type: "success",
            content: "Submitted successfully.",
            dismissible: true,
            dismissLabel: "Dismiss message",
            onDismiss: () => setFlashItem([]),
            id: "message_1"
        }
    ]);
    const [isLoading, setIsLoading] = useState(false);
    const [files, setFiles] = useState([])
    const [
        selectedItem,
        setSelectedItem
    ] = useState([]);
    const navigate = useNavigate();



    const handleDelete = async () => {
        setIsLoading(true);
        try {
            const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
            if (authToken) {
                const file = selectedItem[0]
                const restOperation = del({
                    apiName: 'textTuner',
                    path: '/file',
                    options: {
                        queryParams: {
                            file: file.file_name,
                        },
                        headers: {
                            Authorization: authToken
                        }
                    },

                });
                const { body } = await restOperation.response;
                await body.json();
            }

        } catch (error) {
        }
        await reload();
        setIsLoading(false);
    }

    const handleDownload = async (file, version) => {
        var downloadName = file.file_original.slice(0, file.file_original.lastIndexOf("."));
        if (version === "corrected") {
            downloadName += "-unified"
        } else {
            downloadName += "-" + version
        }
        try {
            const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
            if (authToken) {
                const restOperation = get({
                    apiName: 'textTuner',
                    path: '/file',
                    options: {
                        queryParams: {
                            file: file.file_name,
                            version: version
                        },
                        headers: {
                            Authorization: authToken
                        }
                    },

                });
                const { body } = await restOperation.response;

                const json = await body.json();
                const pre_signed_url = json.pre_signed_url
                console.log(pre_signed_url)
                await fetch(pre_signed_url).then((response) => {
                    response.blob().then((blob) => {
                        const fileURL =
                            window.URL.createObjectURL(blob);
                        let alink = document.createElement("a");
                        alink.href = fileURL;
                        // alink.download = file.file_name + "-" + version;
                        alink.download = downloadName;
                        alink.click();
                    });
                });;
            }

        } catch (error) {
        }

    };

    const reload = useCallback(async () => {
        setIsLoading(true)
        setSelectedItem([])
        const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
        if (authToken) {
            const restOperation = get({
                apiName: 'textTuner',
                path: '/files',
                options: {
                    headers: {
                        Authorization: authToken
                    }
                },
            });
            const { body } = await restOperation.response;
            const json = await body.json();
            const array = (json)
            console.log(array)
            setFiles(array);
        }
        setIsLoading(false)
    }, [])

    useEffect(() => {
        reload();
    }, [reload]);
    // TODO allow sorting by date in table
    // TODO add pagination to table
    // TODO add icons to table


    return (
        <Container
            header={
                <Header
                    variant="h2"
                    actions={<SpaceBetween direction="horizontal" size="xs">

                        <Button variant="primary" onClick={() => navigate('/text-tuner/new')}>
                            New
                        </Button>
                        <Button
                            disabled={(selectedItem.length === 0) ? true : false}
                            variant="normal"
                            onClick={handleDelete}>
                            Delete
                        </Button>
                        <Button iconName="refresh" variant="normal" onClick={reload}>
                            Refresh
                        </Button>
                    </SpaceBetween>}
                >
                    My Documents
                </Header>

            }
        >
            <Flashbar items={state ? flashItem : []} />

            <Table
                variant='borderless'
                columnDefinitions={[
                    {
                        id: "date",
                        header: "Date",
                        cell: item => getDate(item.file_timestamp)
                    },
                    {
                        id: "name",
                        header: "Name",
                        cell: item => item.file_original,

                    },
                    {
                        id: "original",
                        header: "Original File",
                        cell: item =>
                            <Link
                                onFollow={() =>
                                    handleDownload(item, 'original')
                                }
                            >
                                <FaFile />
                            </Link>
                    },
                    {
                        id: "correction",
                        header: "Unified File",
                        cell: item => (item['state'] === 'complete') ?
                            <Link
                                onFollow={() =>
                                    handleDownload(item, 'corrected')
                                }
                            >
                                <FaFile />
                            </Link>
                            : "processing..."
                    }
                ]}
                columnDisplay={[
                    { id: "date", visible: true },
                    { id: "name", visible: true },
                    { id: "original", visible: true },
                    { id: "correction", visible: true },
                ]}
                enableKeyboardNavigation
                items={files}
                selectionType="single"
                selectedItems={selectedItem}
                onSelectionChange={({ detail }) => {
                    setSelectedItem(detail.selectedItems)
                }

                }
                trackBy="file_name"
                empty={
                    <Box
                        margin={{ vertical: "xs" }}
                        textAlign="center"
                        color="inherit"
                    >
                        <SpaceBetween size="m">
                            <b>No Documents</b>
                            <Button variant='primary' onClick={() => navigate('/text-tuner/new')}>Add New</Button>
                        </SpaceBetween>
                    </Box>
                }
                loading={isLoading}
                loadingText={"Loading Documents"}
            />
        </Container >
    )
}

export default TextTunerList;